"use strict";

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _remark = _interopRequireDefault(require("remark"));

var _remarkParse = _interopRequireDefault(require("remark-parse"));

var _remarkReact = _interopRequireDefault(require("remark-react"));

var Jumbotron = function Jumbotron(props) {
  var justifyContent = '';
  var align = '';

  switch (props.data.align) {
    case 'center':
      justifyContent = 'center';
      align = 'has-text-centered';
      break;

    case 'left':
      justifyContent = 'flex-start';
      align = 'has-text-left';
      break;

    case 'right':
      justifyContent = 'flex-end';
      align = 'has-text-right';
      break;
  }

  return (
    /*#__PURE__*/
    _react["default"].createElement("div", {
      className: "full-width-image margin-top-0",
      style: {
        backgroundImage: "url(".concat(!!props.data.image.childImageSharp ? props.data.image.childImageSharp.fluid.src : props.data.image, ")"),
        backgroundPosition: 'top center',
        backgroundAttachment: 'fixed',
        height: "".concat(props.data.height, "px"),
        position: 'relative',
        justifyContent: "".concat(justifyContent),
        maxWidth: "100%"
      }
    },
    /*#__PURE__*/
    _react["default"].createElement("div", {
      className: "background-overlay",
      style: {
        backgroundColor: "".concat(props.data.overlay.backgroundColor),
        opacity: "".concat(props.data.overlay.opacity)
      }
    }),
    /*#__PURE__*/
    _react["default"].createElement("div", {
      className: "".concat(align, " has-text-white-ter"),
      style: {
        lineHeight: '1',
        flexDirection: 'column',
        zIndex: 1,
        padding: '0rem 3rem'
      }
    }, props.data.titles != null ?
    /*#__PURE__*/
    _react["default"].createElement(_react["default"].Fragment, null, props.data.titles.map(function (title) {
      return (
        /*#__PURE__*/
        _react["default"].createElement("div", {
          className: "".concat(title.sizeMobile, "-mobile ").concat(title.sizeTablet, "-tablet ").concat(title.sizeWidescreen, "-widescreen"),
          style: {
            lineHeight: '1',
            maxWidth: '100%',
            paddingBottom: '1.5rem',
            textAlign: "".concat(title.align)
          }
        }, (0, _remark["default"])().use(_remarkParse["default"]).use(_remarkReact["default"]).processSync(title.value).contents)
      );
    })) : null))
  );
};

var _default = Jumbotron;
exports["default"] = _default;